import type { AddressSearchResult } from '@domgen/base-design-system-2.0/molecules/AddressSearchInput';

export function validateAddressMatch(
  formValues: Record<string, string | null | undefined>,
  selectedAddress: AddressSearchResult | null | undefined,
  isMerchandiseLocation = false,
): boolean {
  if (!selectedAddress) {
    return false;
  }

  const fieldsToCompare: (keyof AddressSearchResult)[] = [
    'addressLine1',
    'city',
    'regionOrStateCode',
    'postalCode',
  ];

  for (const field of fieldsToCompare) {
    let formValue: string;

    if (isMerchandiseLocation) {
      const merchandiseField =
        'merchandiseLocation' + field.charAt(0).toUpperCase() + field.slice(1);
      formValue = String(formValues[merchandiseField] ?? '').trim();
    } else {
      formValue = String(formValues[field as string] ?? '').trim();
    }

    const selectedValue = String(selectedAddress[field] ?? '').trim();

    if (formValue !== selectedValue) {
      return false;
    }
  }

  return true;
}
